import { useEffect, useState } from "react";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useOutsideClick } from "src/utils/useOutsideClick";
import "./singleCalendar.scss";

interface SingleCalendarModal {
  closeModal: () => void;
  onDateChange: (date: Date) => void;
  initialDate?: Date;
}

export const CalendarModalSingleDate = ({
  closeModal,
  onDateChange,
  initialDate,
}: SingleCalendarModal) => {
  const [selectedDate, setSelectedDate] = useState<Date>(
    initialDate || new Date(),
  );

  const modalRef = useOutsideClick(() => {
    closeModal();
  }, "click");

  useEffect(() => {
    document.querySelectorAll(".rdrWeekDays").forEach((weekDays) => {
      weekDays.querySelectorAll(".rdrWeekDay").forEach((day, index) => {
        const days = ["S", "M", "T", "W", "T", "F", "S"];
        day.textContent = days[index];
      });
    });
  }, []);

  const handleDateSelect = (date: Date) => {
    setSelectedDate(date);
  };

  const applyDate = () => {
    onDateChange(selectedDate);
    closeModal();
  };

  return (
    <div ref={modalRef} className="modalContainerSingle">
      <div className="calendarContainer">
        <div className="containerSingle">
          <Calendar
            date={selectedDate}
            onChange={handleDateSelect}
            className="calendarSignle"
          />
          <button className="applyButtonSingle" onClick={applyDate}>
            APPLY
          </button>
        </div>
      </div>
    </div>
  );
};
